import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Form, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {formatarReal, formatarValorReal} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";
import moment from "moment/moment";

@inject("store")
@observer
export class DetalhamentoTotal extends Component {

    static propTypes = {
        controller: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.controller = this.props.controller;
    }

    render() {

        return (
            <div>
                <h4>Totais</h4>
                <Row>
                    <Col xs={12} md={3} lg={3}>
                        <FormGroup>
                            <Label>Total bruto</Label>
                            <Input type="text" value={formatarValorReal(this.controller.totalBruto)} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={3} lg={3}>
                        <FormGroup>
                            <Label>Encargos ETT</Label>
                            <Input type="text" value={formatarValorReal(this.controller.encargosEtt)} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={3} lg={3}>
                        <FormGroup>
                            <Label>VT / VR / ASO / Reembolso de viagens</Label>
                                <Input type="text" value={formatarValorReal(this.controller.VtVrAsoReembolsoViagens)} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={3} lg={3} />
                    <Col xs={12} md={3} lg={3}>
                        <FormGroup>
                            <Label>Total geral</Label>
                            <Input type="text" value={formatarValorReal(this.controller.totalGeral)} readOnly/>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}